import React from 'react'

import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components/macro'
import { updateSelectedFilters } from 'store/actions/filters'
import { NUTS_LEVEL_COLOR_MAPPING } from 'store/constants/constants'
import SearchFilterButton from 'components/ui/SearchFilterButton'
import SelectedFilterContainer from 'components/ui/SelectedFilterContainer'
import FilterText from 'components/ui/FilterText'
import RemoveIcon from 'components/ui/RemoveIcon'
import CARMap from 'components/CountriesAndRegionsResults'
import { t } from 'ttag'

const NutsLevelSelector = styled.ul`
  list-style-type: none;
  left: -5px;
  padding: 0 0;
  top: 0;
`
const ButtonWrapper = styled.div`
  margin: 1rem 0 0 0;
  svg {
    display: none;
  }
`
const SelectedRegionFilter = styled.div`
  padding: 4px 10px 4px 6px;
  margin: 3px;
  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
  border-radius: 2px;
  color: white !important;
  display: block;
  position: relative;
  background-color: ${props => NUTS_LEVEL_COLOR_MAPPING[props.level]};
  > div > div {
    color: white !important;
  }
  i.fa.times:before {
    color: white !important;
  }
`

function NutsSelector() {
  const dispatch = useDispatch()
  const filters = useSelector(state => state.filters)
  const { currentSearchable } = filters
  const { nutsLevel, regions } = filters.selectedFilters[currentSearchable].options
  const handleNutsLevelClick = level => {
    const data = {
      filterValue: level,
      filterType: 'options',
      filterId: 'nutsLevel'
    }
    dispatch(updateSelectedFilters(data))
  }
  const handleRemove = id => {
    const newRegions = regions.filter(r => r.id !== id)
    const data = {
      filterValue: newRegions,
      filterType: 'options',
      filterId: 'regions'
    }
    const data2 = {
      filterValue: newRegions.map(r => ({ id: r.id })),
      filterType: 'programmes',
      filterId: 'nuts'
    }
    dispatch(updateSelectedFilters(data))
    dispatch(updateSelectedFilters(data2))
  }
  const info = t`Click on the map to select NUTS ${nutsLevel} region(s)`
  return (
    <NutsLevelSelector>
      {regions.map(r => (
        <SelectedFilterContainer className="selected-filters" key={r.id ? r.id : r}>
          <SelectedRegionFilter level={r.type}>
            <FilterText title={r.label ? r.label : r}>
              {r.english_alias ? r.english_alias : r.label || r}
            </FilterText>
            <RemoveIcon className="far fa-times" onClick={() => handleRemove(r.id)} />
          </SelectedRegionFilter>
        </SelectedFilterContainer>
      ))}
      <ButtonWrapper>
        <SearchFilterButton
          nutsLevel={0}
          active={nutsLevel === 0}
          onClick={() => handleNutsLevelClick(0)}
          name="NUTS0"
          subTitle={nutsLevel === 0 ? info : ''}
        />
      </ButtonWrapper>
      <ButtonWrapper>
        <SearchFilterButton
          nutsLevel={1}
          active={nutsLevel === 1}
          onClick={() => handleNutsLevelClick(1)}
          name="NUTS1"
          subTitle={nutsLevel === 1 ? info : ''}
        />
      </ButtonWrapper>
      <ButtonWrapper>
        <SearchFilterButton
          nutsLevel={2}
          active={nutsLevel === 2}
          onClick={() => handleNutsLevelClick(2)}
          name="NUTS2"
          subTitle={nutsLevel === 2 ? info : ''}
        />
      </ButtonWrapper>
      <ButtonWrapper>
        <SearchFilterButton
          nutsLevel={3}
          active={nutsLevel === 3}
          onClick={() => handleNutsLevelClick(3)}
          name="NUTS3"
          subTitle={nutsLevel === 3 ? info : ''}
        />
      </ButtonWrapper>
      <CARMap onlyMap searchResults={{}} />
    </NutsLevelSelector>
  )
}

export default NutsSelector
